import { render, staticRenderFns } from "./mian-bottom.vue?vue&type=template&id=795f68bc&scoped=true"
import script from "./mian-bottom.vue?vue&type=script&lang=js"
export * from "./mian-bottom.vue?vue&type=script&lang=js"
import style0 from "./mian-bottom.vue?vue&type=style&index=0&id=795f68bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795f68bc",
  null
  
)

export default component.exports